import type { AxiosRequestConfig } from "axios";
import http from "http";
import https from "https";
import Cookies from "js-cookie";

const headers: any = {
  "Content-Type": "application/json;charset=UTF-8",
  "X-Requested-With": "XMLHttpRequest",
  lang: Cookies.get("lang"),
  "x-sys-lang": typeof navigator !== "undefined" ? navigator.language : "",
  "x-tz":
    typeof window !== "undefined"
      ? Intl.DateTimeFormat().resolvedOptions().timeZone
      : "",
};

const token = Cookies.get("token");
if (token) {
  headers["token"] = token;
}

const config: AxiosRequestConfig = {
  headers: headers,
  timeout: 1000 * 10,
  withCredentials: true,
  responseType: "json",
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  // 用于node.js
  httpAgent: new http.Agent({
    keepAlive: true,
  }),
  httpsAgent: new https.Agent({
    keepAlive: true,
  }),
};

export default config;
